<template>
  <div class="page" data-page="start">
    <div id="page-logo">
      <img class="brand-logo" :src="$store.getters.getLogo || '../assets/logo_tmp.png'" />
    </div>
    <div class="container pt-4">
      <div class="row">
        <template v-if="this.$store.getters.getReady">
          <div class="col-2 sidebar-left"></div>
          <div class="col-8 card main-card" ref="mainCard">
            <Carousel
              :startSlide="0"
              :tabsActive="true"
              :skipFirstTab="true"
              :morePadding="true"
              ref="carousel"
            >
              <Slide class="slide-lo-yesno" :index="0" :disableFooter="true">
                <h2 class="bold">{{haveOfficerText}}</h2>
                <p class="margin-b">
                  No worries if you don't, we'll match you with a local professional to help you along your journey.
                </p>
                <InputBoolean
                  v-model="
                    $store.state.saveData['start']['has_loan_officer_yesno']
                  "
                  :data="{
                    Id: 'has_loan_officer_yesno',
                    Type: 23,
                    Icon: 'far fa-thumbs-up',
                    Text: 'Yes or No',
                    Required: false,
                    FieldSpan: false
                  }"
                  :callbackYes="onHasLoanOfficerYes"
                  :callbackNo="onHasLoanOfficerNo"
                />
              </Slide>
              <Slide class="slide-lo-search" :index="1" :disableFooter="true">
                <h2 class="bold">Great! Let's see if we can find them</h2>
                <p class="margin-b">
                  Use the search field below to search for them using their name.
                </p>
<!--
                <div class="slide-left">
                  <InputText v-model="LOSearch.form.Name" :data="{ Id: 'loan_officer_name', Text: haveOfficerPlaceholder, Required: false }" :useLabel="false" />
                </div>
                <div class="slide-middle" style="display: none;">Or</div>
                <div class="slide-right" style="display: none;">
                  <label for="loan_officer_zip">Do you know their zip code?</label>
                  <InputInteger v-model="LOSearch.form.Zip" :data="{ Id: 'loan_officer_zip', Text: 'Zip Code', Required: false }" :useLabel="false" />
                </div>
                <div class="search-button-wrapper">
                  <button type="button" class="btn-primary" @click="onLOSearch">
                    <icon icon="search"></icon> Search
                  </button>
                </div>
-->
                <div class="intro-search">
                  <div>
                    <InputText v-model="LOSearch.form.Name" :data="{ Id: 'loan_officer_name', Text: haveOfficerPlaceholder, Required: false }" :useLabel="false" />
                  </div>
                  <div class="search-button-wrapper">
                    <button type="button" class="btn-primary" @click="onLOSearch">
                      <icon icon="search"></icon> Search
                    </button>
                  </div>
                </div>


                <div class="results" v-if="LOSearch.HasSearched">
                  <h4 class="bold">Top 5 Matches</h4>
                  <template v-for="(officer, index) in LOSearch.Officers">
                    <div class="lo-search-result" :key="'officer_' + index">
                      <div class="officer-photo" :style="{ 'background-image': 'url(' + officer.Avatar + ')' }" v-if="officer.Avatar"></div>
                      <div class="officer-photo" v-else></div>
                      <div class="officer-info">
                        <div class="title bold">
                          <h3 class="bold">
                            {{ officer.FullName }}
                          </h3>
                          <span v-if="officer.Title">
                            - {{ officer.Title }}</span
                          >
                        </div>
                        <div class="contact-nmls" v-if="officer.NMLS">
                          NMLS# {{ officer.NMLS }}
                        </div>
                        <div class="contact-phone" v-if="officer.Phone">
                          <icon icon="phone" /> {{ officer.Phone }}
                        </div>
                        <div class="contact-email" v-if="officer.Email">
                          <icon icon="envelope" /> {{ officer.Email }}
                        </div>
                        <div
                          class="contact-zip"
                          v-if="officer.Address && officer.Address.Zip"
                        >
                          <icon icon="globe" /> {{ officer.Address.Zip }}
                        </div>
                      </div>
                      <div class="officer-select">
                        <button
                          type="button"
                          class="btn-primary"
                          @click="onLOSelect(officer)"
                        >
                          Select
                        </button>
                      </div>
                    </div>
                  </template>
                  <div v-if="LOSearch.Officers.length == 0">
                    <div class="lo-search-result">No Matching Officers Found</div>
                  </div>
                </div>
                <div class="search-back">
                  <button class="btn btn-default" @click="$refs['carousel'].goTo(0)">Back</button>
                </div>
              </Slide>
              <Slide class="slide-welcome" :index="2" icon="rocket" title="Welcome" subtitle="Let's get started" :disableFooter="true">
                <div class="slide-left">
                  <h2 class="bold">We're here to help!</h2>
                  <p v-html="this.$store.getters.getWelcomeMessage"></p>
                  <button type="button" class="btn-primary" @click="onWelcomeContinue">
                    Continue
                  </button>
                </div>
                <div class="slide-right">
                  <div class="loan-officer-card">
                    <div class="inner">
                      <div class="officer-photo" :style="{ 'background-image': 'url(' + this.$store.getters.getAvatar + ')' }" v-if="this.$store.getters.getAvatar"></div>
                      <div v-else></div>
                      <div class="officer-info">
                        <h2 class="bold">
                          {{ this.$store.getters.getFullName }}
                        </h2>
                        <div class="sub text-gray" v-if="this.$store.getters.getTitle">
                          {{ this.$store.getters.getTitle }}
                        </div>
                        <div class="sub text-gray" v-if="this.$store.getters.getNMLS">
                          <a href="https://nmlsconsumeraccess.org/" target="_blank">NMLS# {{ this.$store.getters.getNMLS }}</a>
                        </div>
                      </div>
                      <hr />
                      <div class="officer-contact">
                        <div class="contact-phone" v-if="this.$store.getters.getPhone">
                          <a :href="'tel:' + this.$store.getters.getPhone">
                            <icon icon="phone" />
                            {{ this.$store.getters.getPhone }}
                          </a>
                        </div>
                        <div class="contact-email" v-if="this.$store.getters.getEmail">
                          <a :href="'mailto:' + this.$store.getters.getEmail">
                            <icon icon="envelope" />
                            {{ this.$store.getters.getEmail }}
                          </a>
                        </div>
                        <div class="contact-website" v-if="this.$store.getters.getWebsite">
                          <a :href="this.$store.getters.getWebsite" target="_blank">
                            <icon icon="globe" />
                            {{ this.$store.getters.getWebsite }}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Slide>
              <Slide class="slide-borrower-intro" :index="3" icon="user" title="Introduction" subtitle="Introduce yourself" :buttonCallback="onCompleteIntroduction">
                <h2 class="bold">Introduce yourself</h2>
                <label for="loan_borrower_firstname">
                  We need a little more information from you before we can start your application
                </label>
                <div class="slide-left">
                  <InputText v-model="$store.state.saveData['start']['loan_borrower_firstname']" :data="{ Id: 'loan_borrower_firstname', Text: 'First Name', Required: true }" :useLabel="false" :class="{ invalid: !$store.state.borrowers[0].FirstName.isValid }" @input:isvalid="$store.state.borrowers[0].FirstName.isValid = $event" @input:value-parsed="$store.state.borrowers[0].FirstName.value = $event" v-if="$store.state.borrowers[0]" />
                </div>
                <div class="slide-right">
                  <InputText v-model="$store.state.saveData['start']['loan_borrower_lastname']" :data="{ Id: 'loan_borrower_lastname', Text: 'Last Name', Required: true }" :useLabel="false" :class="{ invalid: !$store.state.borrowers[0].LastName.isValid }"  @input:isvalid="$store.state.borrowers[0].LastName.isValid = $event" @input:value-parsed="$store.state.borrowers[0].LastName.value = $event" v-if="$store.state.borrowers[0]" />
                </div>
                <label for="loan_borrower_email">
                  How can we keep in touch?
                </label>
                <div class="slide-left">
                  <InputEmail v-model="$store.state.saveData['start']['loan_borrower_email']" :data="{ Id: 'loan_borrower_email', Text: 'Email', Required: true }" :useLabel="false" :class="{ invalid: !$store.state.borrowers[0].Email.isValid }" @input:isvalid="$store.state.borrowers[0].Email.isValid = $event" @input:value-parsed="$store.state.borrowers[0].Email.value = $event" v-if="$store.state.borrowers[0]" />
                </div>
                <div class="slide-right">
                  <InputPhone v-model="$store.state.saveData['start']['loan_borrower_phone']" :data="{ Id: 'loan_borrower_phone', Text: 'Phone', Required: true }" :useLabel="false" :class="{ invalid: !$store.state.borrowers[0].Phone.isValid }" @input:isvalid="$store.state.borrowers[0].Phone.isValid = $event" @input:value-parsed=" $store.state.borrowers[0].Phone.value = $event" v-if="$store.state.borrowers[0]" />
                </div>
                <label for="loan_borrower_loantype">
                  What type of loan are you looking for?
                </label>
                <InputDropdown v-model="$store.state.saveData['start']['loan_borrower_loantype']" :data="{ Id: 'loan_borrower_loantype', Text: 'Loan Type', Options: [ { Text: 'Purchase', Value: 'Purchase' }, { Text: 'Refinance', Value: 'Refinance' }, { Text: 'Construction', Value: 'Construction' }, { Text: 'Home Equity Line of Credit', Value: 'HELOC' } ], Required: true }" :useLabel="false" :class="{ invalid: !$store.state.loan.Type.isValid }" @input:isvalid="$store.state.loan.Type.isValid = $event" @input:value-parsed="$store.state.loan.Type.value = $event" v-if="$store.state.borrowers[0]" />
                <label for="loan_borrower_count">
                  Are you applying by yourself? Or jointly?
                </label>
                <InputDropdown v-model="$store.state.saveData['start']['loan_borrower_count']" :data="{ Id: 'loan_borrower_count', Text: 'Borrower Count', Options: [ { Text: 'It\'s just me', Value: 'single' }, { Text: 'Jointly', Value: 'multiple' } ], Required: true }" :useLabel="false" :class="{ invalid: !$store.state.loan.BorrowerCount.isValid }" @input:isvalid="$store.state.loan.BorrowerCount.isValid = $event" @input:value-parsed=" $store.state.loan.BorrowerCount.value = $event" />
              </Slide>
              <Slide class="slide-co-borrowers" :index="4" icon="user-friends" title="Co-Borrowers" subtitle="Who else is applying?" :tabHidden="isCoBorrowerTabHidden" :buttonCallback="onCompleteCoBorrowers">
                <h2 class="bold">Who else is applying with you?</h2>
                <template v-for="(borrower, index) in $store.state.borrowers">
                  <div class="borrower-wrapper" :key="'borrower_' + index" v-if="index > 0">
                    <div class="borrower-title">
                      <div class="borrower-delete float-right" @mousedown="removeBorrower(index)">
                        <icon :icon="['fas', 'minus-circle']" /> Remove this Co-Borrower
                      </div>
                      <h4>Borrower {{ index + 1 }}</h4>
                    </div>
                    <div class="slide-left no-label">
                      <InputText v-model="$store.state.saveData['start']['loan_borrower' + index + '_firstname']" :data="{ Id: 'loan_borrower' + index + '_firstname', Text: 'First Name', Required: true }" :useLabel="false" :class="{ invalid: !borrower.FirstName.isValid }" @input:isvalid="borrower.FirstName.isValid = $event" @input:value-parsed="borrower.FirstName.value = $event" v-if="borrower" />
                    </div>
                    <div class="slide-right no-label">
                      <InputText v-model="$store.state.saveData['start']['loan_borrower' + index + '_lastname']" :data="{ Id: 'loan_borrower' + index + '_lastname', Text: 'Last Name', Required: true }" :useLabel="false" :class="{ invalid: !borrower.LastName.isValid }" @input:isvalid="borrower.LastName.isValid = $event" @input:value-parsed="borrower.LastName.value = $event" v-if="borrower" />
                    </div>
                    <div class="slide-left no-label">
                      <InputEmail v-model="$store.state.saveData['start']['loan_borrower' + index + '_email']" :data="{ Id: 'loan_borrower' + index + '_email', Text: 'Email', Required: true }" :useLabel="false" :class="{ invalid: !borrower.Email.isValid }" @input:isvalid="borrower.Email.isValid = $event" @input:value-parsed="borrower.Email.value = $event" v-if="borrower" />
                    </div>
                    <div class="slide-right no-label">
                      <InputPhone v-model="$store.state.saveData['start']['loan_borrower' + index + '_phone']" :data="{ Id: 'loan_borrower' + index + '_phone', Text: 'Phone', Required: true }" :useLabel="false" :class="{ invalid: !borrower.Phone.isValid }" @input:isvalid="borrower.Phone.isValid = $event" @input:value-parsed="borrower.Phone.value = $event" v-if="borrower" />
                    </div>
                    <label :for="'loan_borrower' + index + '_spouse'">Is this borrower married to anyone on this loan?</label>
                    <InputDropdown v-model="$store.state.saveData['start']['loan_borrower' + index + '_spouse']" :data="{ Id: 'loan_borrower' + index + '_spouse', Text: 'Married to Borrower', Options: filteredSpouses(index), Required: true }" :useLabel="false" :class="{ invalid: !borrower.marriedTo.isValid }" @input:isvalid="borrower.marriedTo.isValid = $event" @input:value-parsed="onMarriedToChange(borrower, $event)" v-if="borrower" />
<!--
                    <label :for="'loan_borrower' + index + '_onbehalf'">Are you filling out the application on behalf of this borrower? Or should we invite them to fill it out themselves?</label>
                    <InputDropdown v-model="$store.state.saveData['start']['loan_borrower' + index + '_onbehalf']" :data="{ Id: 'loan_borrower' + index + '_onbehalf', Text: 'Filling on Behalf', Options: [{ Text: 'Yes, I will fill it out on their behalf.', Value: 'yes' }, { Text: 'No, send them an invitation.', Value: 'no' }], Required: true }" :useLabel="false" :class="{ invalid: !borrower.fillingOnBehalf.isValid }" @input:isvalid="borrower.fillingOnBehalf.isValid = $event" @input:value-parsed=" onFillingOnBehalfChange(borrower, $event)" v-if="borrower" />
-->
                  </div>
                </template>
                <div class="additional-borrower-wrapper text-center">
                  <a href="#" @click.prevent @mousedown="onAdditionalBorrowerClick">+ Add additional Borrower</a>
                </div>
              </Slide>
            </Carousel>
          </div>
          <div class="col-2 sidebar-right"></div>
        </template>
      </div>
    </div>
    <DisclaimerFooter />
    <template v-for="(toast, index) in $store.getters.getToasts">
      <Toast :data="toast" :index="index" :key="'toast_' + index" />
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import PreApproveMe from '@/services/PreApproveMe.js'
import Terms from '@/services/terms.js'

import Carousel from '@/components/Carousel.vue'
import InputBoolean from '@/inputs/InputBoolean.vue'
import InputDropdown from '@/inputs/InputDropdown.vue'
import InputEmail from '@/inputs/InputEmail.vue'
//import InputInteger from '@/inputs/InputInteger.vue'
import InputPhone from '@/inputs/InputPhone.vue'
import InputText from '@/inputs/InputText.vue'
import Slide from '@/components/Slide.vue'
import Toast from '@/components/Toast.vue'
import DisclaimerFooter from '@/components/DisclaimerFooter.vue'

export default {
  name: 'PageStart',
  components: {
    Carousel,
    InputBoolean,
    InputDropdown,
    InputEmail,
//    InputInteger,
    InputPhone,
    InputText,
    Slide,
    Toast,
    DisclaimerFooter
  },
  data: () => {
    return {
      isCoBorrowerTabHidden: true,
      LOSearch: {
        HasSearched: false,
        Loading: false,
        Officers: [],
        Name: '',
        Zip: '',
        form: {
          Name: '',
          Zip: ''
        }
      }
    }
  },
  computed: {
    haveOfficerText: function () {
      return Terms.replace('Do you already have a {{loanofficer}}?')
    },
    haveOfficerPlaceholder: function () {
      return Terms.replace('{{loanofficer}} Name')
    }
  },
  methods: {
    alert: function(msg, type) {
      type = typeof type !== 'undefined' ? type : 'error'
      this.$store.commit('openToast', {
        text: msg,
        type
      })
    },
    onHasLoanOfficerYes: function() {
      const slider = this.$refs['carousel']
      slider.next()
    },
    onHasLoanOfficerNo: function() {
      const slider = this.$refs['carousel']
      slider.goTo(2)
    },
    onLOSearch: function() {
      PreApproveMe.searchOfficer(this.LOSearch.form.Name, this.LOSearch.form.Zip)
        .then(r => {
          this.LOSearch.Officers = r.Users || []
          this.LOSearch.HasSearched = true
        })
    },
    onLOSelect: function(officer) {
      const slider = this.$refs['carousel']
      this.$store.dispatch('initOfficer', officer)
      .then(r => {
        slider.next()
      })
    },
    onWelcomeContinue: function() {
      const slider = this.$refs['carousel']
      slider.next()
    },
    onCompleteIntroduction: function() {
      this.$root.$emit('form:validate-force')
      let isFilled = true
      for (let i = 0; i < this.$store.state.borrowers.length; i++) {
        const currBorrower = this.$store.state.borrowers[i]
        if (
          i == 0 &&
          (!currBorrower.FirstName.value ||
            !currBorrower.FirstName.isValid ||
            !currBorrower.LastName.value ||
            !currBorrower.LastName.isValid ||
            !currBorrower.Email.value ||
            !currBorrower.Email.isValid ||
            !currBorrower.Phone.value ||
            !currBorrower.Phone.isValid ||
            !this.$store.state.loan.Type.value ||
            !this.$store.state.loan.Type.isValid ||
            !this.$store.state.loan.BorrowerCount.value ||
            !this.$store.state.loan.BorrowerCount.isValid)
        )
          isFilled = false
      }
      if (isFilled) {
        if (this.$store.state.loan.BorrowerCount.value == 'multiple') {
          if (!this.$store.state.borrowers[1]) this.$store.commit('addBorrower')
          this.isCoBorrowerTabHidden = false
          const slider = this.$refs['carousel']
          slider.next()
        } else {
          while (this.$store.state.borrowers.length > 1)
            this.removeBorrower(1)
          this.submitBorrowers()
        }
      } else {
        this.isCoBorrowerTabHidden = true
        if (this.borrower) this.$store.state.borrowers.splice(1)
        let missing_fields = 'Missing required fields:<br><ul>'
        if (!this.$store.state.borrowers[0].FirstName.isValid) {
          missing_fields = missing_fields + '<li>First Name</li>'
        }
        if (!this.$store.state.borrowers[0].LastName.isValid) {
          missing_fields = missing_fields + '<li>Last Name</li>'
        }
        if (!this.$store.state.borrowers[0].Email.isValid) {
          missing_fields = missing_fields + '<li>Email</li>'
        }
        if (!this.$store.state.borrowers[0].Phone.isValid) {
          missing_fields = missing_fields + '<li>Phone</li>'
        }
        if (!this.$store.state.loan.Type.isValid) {
          missing_fields = missing_fields + '<li>Loan Type</li>'
        }
        if (!this.$store.state.loan.BorrowerCount.isValid) {
          missing_fields = missing_fields + '<li>Number of applicants</li>'
        }
        missing_fields = missing_fields + '</ul>'
        this.alert(missing_fields, 'error')
      }
    },
    filteredSpouses: function (index) {
      var filtered = [{ Text: 'No', Value: 'no' }]
      var borrowers = this.$store.getters.getBorrowers

      for (var i = 0; i < borrowers.length; i++) {
        if (i === index)
          continue

       var id_token = ''
       if (i > 0) id_token = i

       var spouseValue = this.$store.state.saveData['start']['loan_borrower' + id_token + '_spouse']
       if (spouseValue != 'no' && spouseValue != null && spouseValue != undefined && spouseValue != index + '')
         continue

       filtered.push({ Text: 'Yes, they are married to ' + borrowers[i].FirstName.value + ' ' + borrowers[i].LastName.value, Value: i + '' })
      }

      return filtered
    },
    onAdditionalBorrowerClick: function() {
      this.$store.commit('addBorrower')
    },
    // onIsMarriedChange: function(borrower, $event) {
    //   borrower.isMarried.value = $event
    //   // borrower.Spouse = $event == 'yes' ? 0 : false
    // },
    onMarriedToChange: function(borrower, $event) {
      borrower.marriedTo.value = $event
      // borrower.Spouse = $event == 'no' ? false : $event

      // Look up index of the borrower the event happened on
      var borrowers = this.$store.getters.getBorrowers
      var borrowerIndex = -1
      for (var i = 0; i < borrowers.length; i++)
        if (borrower == borrowers[i])
          borrowerIndex = i

      // If we have a borrower, then update the person we are married to
      if (borrowerIndex !== -1) {
        for (var i = 0; i < borrowers.length; i++) {
          var id_token = ''
          if (i > 0) id_token = i

          var spouseValue = this.$store.state.saveData['start']['loan_borrower' + id_token + '_spouse']

          // Update the person we are married to so that they point back to us
          if (i == borrower.marriedTo.value * 1) {
            if (spouseValue != borrowerIndex + '')
              Vue.set(this.$store.state.saveData['start'], 'loan_borrower' + id_token + '_spouse', borrowerIndex + '')
          }
          // Update anyone who might currently say they are married to us not to be
          else if (spouseValue == borrowerIndex + '') {
              Vue.set(this.$store.state.saveData['start'], 'loan_borrower' + id_token + '_spouse', 'no')
          }
        }
      }
    },
    onFillingOnBehalfChange: function(borrower, $event) {
      borrower.fillingOnBehalf.value = $event
      // borrower.isActive = $event == 'yes' ? true : false
    },
    removeBorrower: function(index) {
      if (index > 0) {
        if (index == 1) {
          this.isCoBorrowerTabHidden = true
          const slider = this.$refs['carousel']
          slider.prev()
        }
        this.$store.state.borrowers.splice(index, 1)
      }
    },
    onCompleteCoBorrowers: function() {
      this.$root.$emit('form:validate-force')
      let isFilled = true
      for (let i = 0; i < this.$store.state.borrowers.length; i++) {
        const currBorrower = this.$store.state.borrowers[i]
        if (
          i > 0 &&
          (!currBorrower.FirstName.value ||
            !currBorrower.FirstName.isValid ||
            !currBorrower.LastName.value ||
            !currBorrower.LastName.isValid ||
            !currBorrower.Email.value ||
            !currBorrower.Email.isValid ||
            !currBorrower.Phone.value ||
            !currBorrower.Phone.isValid ||
            !currBorrower.marriedTo.value ||
            !currBorrower.marriedTo.isValid ||
            !currBorrower.fillingOnBehalf.value ||
            !currBorrower.fillingOnBehalf.isValid)
        )
          isFilled = false
      }
      if (isFilled) {
        this.submitBorrowers()
      } else {
        this.alert('Something was left blank.', 'error')
      }
    },
    submitBorrowers: function() {
      this.$root.isReady = false
      this.$store.dispatch('registerBorrowers').then(() => {
        this.$store.commit('becomeBorrower')
        this.$store.dispatch('go', 'form')
      })
    }
  },
  mounted: function() {
    // If we have an officer already loaded from URL params then automatically select them
    if (!!this.$store.getters.getOfficer)
      this.onHasLoanOfficerNo()

    this.$store.dispatch('initBorrowers')

/*
    const $this = this

    // Get Company ID
    const companyid = '1334'
    this.$store.state.companyid = companyid

    // Check for Loan Officer ID
    const loanofficerid = '4'
    this.$store.state.userid = loanofficerid

    // if (typeof this.$store.state.saveData['start'] == 'undefined')
      this.$store.state.saveData['start'] = {
        loan_borrower_firstname: 'Bob',
        loan_borrower_lastname: 'Bobington',
        loan_borrower_email: 'bob@preapproveme.com',
        loan_borrower_phone: '1231231234',
        loan_borrower_loantype: 'Purchase',
        loan_borrower_count: 'multiple',
        loan_borrower1_firstname: 'Ken',
        loan_borrower1_lastname: 'Kensington',
        loan_borrower1_email: 'ken@preapproveme.com',
        loan_borrower1_phone: '1231231234',
        loan_borrower1_spouse: 'no',
        loan_borrower1_onbehalf: 'yes'
      }

    const t0 = performance.now()
    if (this.$store.state.company === false) {
      PreApproveMe.loadCompany(companyid)
        .then(response => {
          if (
            typeof response == 'object' &&
            response.data &&
            response.data.Success
          ) {
            // Initialize app data
            $this.$store.commit('initCompany', response.data)

            // Add primary borrower
            $this.$store.commit('addBorrower')
            // this.$store.state.borrowers[0].isActive = true

            // Make sure loading takes at least 300 ms
            const t1 = performance.now()
            const timePassed = Math.round(t1 - t0)
            if (timePassed > 300) {
              $this.$root.isReady = true
            } else {
              setTimeout(function() {
                $this.$root.isReady = true
              }, 300 - timePassed)
            }
          } else {
            console.log('Error: Invalid API response.')
          }
        })
        .catch(error => {
          console.log('Error: Invalid API response.', error)
        })
    }
*/
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/_variables.scss';

.page[data-page='start'] {
  #page-logo {
    padding: 4.5rem 0 3rem;
    text-align: center;
    img {
      width: 200px;
    }
  }
  .officer-photo,
  .officer-info {
    display: inline-block;
    vertical-align: middle;
  }
  .officer-info {
    h2,
    h3 {
      margin-top: 10px;
      margin-bottom: 4px;
    }
    h3 {
      display: inline;
    }
    .title {
      color: $black;
      margin-bottom: 6px;
    }
    .sub {
      font-size: 0.85rem;
      margin-bottom: 4px;
    }
  }
  .officer-photo {
    width: 68px;
    height: 68px;
    border-radius: 50%;
    margin-right: 10px;
    background-color: $medium-gray;
    background-image: url('../assets/default-avatar.png');
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .officer-contact {
    display: inline-block;
    text-align: left;
    width: 100%;
    .contact-phone,
    .contact-email,
    .contact-website {
      padding-top: 4px;
      padding-bottom: 4px;
      padding-right: 6px;
      // word-break: break-word;
      white-space: nowrap;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      color: $primary;
      &:last-child {
        padding-bottom: 0;
      }
      .svg-inline--fa {
        float: left;
        color: $primary;
        margin-right: 10px;
      }
    }
  }
  .slide {
    &.slide-lo-yesno {
      p.margin-b {
        margin-bottom: 2rem;
      }
    }
    &.slide-lo-search {
      p.margin-b {
        margin-bottom: 2rem;
      }
      .slide-left,
      .slide-right,
      .slide-middle {
        display: inline-block;
        width: 45%;
        vertical-align: middle;
      }
      .slide-middle {
        color: $black;
        width: 10%;
        text-align: center;
        font-weight: bold;
      }
      .search-button-wrapper {
        //padding-top: 1rem;
        text-align: right;
        button {
          .svg-inline--fa {
            margin-right: 6px;
          }
        }
      }
      .results {
        padding: 1.4rem 0;
        .lo-search-result {
          position: relative;
          padding: 1rem 0;
          border-top: solid 1px $light;
          &:last-child {
            border-bottom: solid 1px $light;
          }
          .officer-photo {
            margin-right: 25px;
          }
          .officer-select {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
          }
          .contact-nmls,
          .contact-phone,
          .contact-email {
            font-size: 0.9rem;
            margin-bottom: 3px;
          }
        }
      }
    }
    &.slide-welcome {
      .slide-left,
      .slide-right {
        display: inline-block;
        width: 50%;
        vertical-align: top;
      }
      .slide-left {
        padding-top: 1rem;
        padding-right: 1rem;
        button {
          margin-top: 10px;
        }
      }
      .slide-right {
        padding-left: 1rem;
        .loan-officer-card {
          position: relative;
          font-size: 0.9rem;
          &:after,
          .inner {
            position: relative;
            z-index: 2;
            background: $lighter-gray;
            border: solid 1px $medium-gray;
            padding: 20px;
          }
          .inner {
            .officer-info {
              width: 60%;
            }
          }
          &:after {
            content: '';
            position: absolute;
            z-index: 1;
            width: 100%;
            height: 100%;
            transform: rotate(2deg);
            top: 0;
            left: 0;
          }
        }
      }
    }
    &.slide-borrower-intro {
      label {
        display: block;
        margin-top: 10px;
      }
      .slide-left,
      .slide-right {
        display: inline-block;
        width: 50%;
        vertical-align: top;
      }
      .slide-left {
        padding-right: 1rem;
      }
      .slide-right {
        padding-left: 1rem;
      }
    }
    &.slide-co-borrowers {
      .borrower-title {
        margin-bottom: 0;
        h4 {
          font-weight: bold;
        }
        .borrower-delete {
          cursor: pointer;
        }
      }
      label {
        display: block;
        margin-top: 10px;
      }
      .borrower-wrapper {
        margin-bottom: 1rem;
      }
      .additional-borrower-wrapper {
        padding-top: 1rem;
      }
      .slide-left,
      .slide-right {
        display: inline-block;
        width: 50%;
        vertical-align: top;
        &.no-label {
          padding-top: 0.5rem;
        }
      }
      .slide-left {
        padding-right: 1rem;
      }
      .slide-right {
        padding-left: 1rem;
      }
    }
  }
  .intro-search {
    display: flex;
    justify-content: space-between;
    
    >:first-child {
      flex-grow: 1;
    }
    >:last-child {
      margin-left: 10px;
    }
  }

  .main-card {
    ::v-deep .slider-tabs {
      display: flex;

      > li {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  .search-back {
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
